import {BaseStars} from "../BaseStars";
import ICustomFormSettings from "../../ICustomFormSettings";
import StarsCell from "../../shared/components/FormCell/StarsCell";

export default class Stars5 extends BaseStars
{

    constructor(setting: ICustomFormSettings) {
        super(setting);

        this.starsItem = new StarsCell(
            5,
            5,
            () => this.getVariable(this.variableName),
            (rating) => this.onSetValue(this.radioItem, rating),
            this.labels
        );

        this.applyEvents();
    }

}